import React, { useState } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import adhaan from "../../images/FlipjoblogoResize.png"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import * as constants from '../../utils/Constants'
import { CircularProgress } from '@mui/material';
import forgetPwdConf1 from "../../images/login_bg/forgetPwdConf1.gif"

const ForgotPasswordConfirmation = () => {
  const [isSpin, setIsSpin] = useState(false)
  const [loginData, setLoginData] = useState({})
  var state = useLocation().state;
  const history = useHistory();
  // const emailId = useParams();
  const searchUrl = window.location.search;
  const token = searchUrl.split('?')[1];

  if (!state) {
    state = {
      emailId: '',
      password: '',
      newPassword: '',
      confirmPassword: '',
    }
  }
  const [input, setInput] = useState({
    emailId: '',
    newpassword: '',
    confirmPassword: '',
  });
  const [error, setError] = useState({
    emailId: '',
    // password: '',
    newPassword: '',
    confirmPassword: '',
  })
  const onInputChange = e => {
    const { name, value } = e.target;
    const newLoginData = { ...loginData }
    newLoginData[e.target.name] = e.target.value
    setLoginData(newLoginData)
    setInput(prev => ({
      ...prev,
      [name]: value
    }));
    validateInput(e);
  }
  const validateInput = e => {
    let { name, value } = e.target;
    setError(prev => {
      const stateObj = { ...prev, [name]: "" };
      switch (name) {
        case "password":
          if (!value) {
            stateObj[name] = "Please enter Password.";
          } else if (input.confirmPassword && value !== input.confirmPassword) {
            stateObj["confirmPassword"] = "Password and Confirm Password does not match.";
          } else {
            stateObj["confirmPassword"] = input.confirmPassword ? "" : error.confirmPassword;
          }
          break;
        case "confirmPassword":
          if (!value) {
            stateObj[name] = "Please enter Confirm Password.";
          } else if (input.newPassword && value !== input.newPassword) {
            stateObj[name] = "Password and Confirm Password does not match.";
          }
          break;
        default:
          break;
      }
      return stateObj;
    });
  }

  const onSubmit = (e) => {
    setIsSpin(true)
    e.preventDefault();
    if (loginData.newPassword !== loginData.confirmPassword) {
      toast.error(`New Password and Confirm Password does not match.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      })
      setIsSpin(false)
      return;
    } else if (loginData.newPassword.length < 4) {
      toast.error(`Password must be at least 4 characters`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      })
      setIsSpin(false)
      return;
    }
    var url = `${constants.ChangePasswordUrl}/${token}`
    fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        Schema: constants.Schema,
      },
      body: JSON.stringify(loginData)
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.message) {
          toast.success(`✅ ${res.message?.messageDescription}`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
          setTimeout(() => {
            history.push({
              pathname: '/page-login',
              state: { email: loginData.emailId }
            })
          }, 3000);
        }

        else {
          toast.error(`❌ ${res.error?.errorMessage}`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
          setTimeout(() => {
            setIsSpin(false)
          }, 3000);
        }
      })

  };
  return (
    <div className="authincation h-100 p-meddle">
      <div className="container h-100"
        style={{ background: '#fff' }}>
        {" "}
        <div className="row justify-content-center h-100 align-items-center">
          <div className='col-md-4 show-results'>
            <img src={forgetPwdConf1} style={{ width: '330px', marginLeft: '20px' }} />
          </div>
          <div className="col-md-8">
            <div className="authincation-content" style={{ boxShadow: 'none' }}>
              <div className="row no-gutters">
                <div className="col-xl-9">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                      <Link to='/'>
                        <img className="brand-title" src={adhaan} alt="" />
                      </Link>
                    </div>
                    <form onSubmit={(e) => onSubmit(e)}>
                      <div className='form-group'>
                        <label className='mb-1 text-#58595b'>
                          <strong>New Password</strong>
                          <span className="text-danger"></span>
                        </label>
                        <input
                          type="password"
                          name="newPassword"
                          placeholder='Enter New Password'
                          //   defaultValue={state.confirmPassword}
                          className='form-control Color-box'
                          //   onChange={handleBlur}
                          value={input.newPassword}
                          onChange={onInputChange}
                          onBlur={validateInput}
                        >
                        </input>
                        {error.password && <span className='err'>{error.password}</span>}
                      </div>
                      <div className='form-group'>
                        <label className='mb-1 text-#58595b'>
                          <strong>Confirm Password</strong>
                          <span className="text-danger"></span>
                        </label>
                        <input
                          type="password"
                          name="confirmPassword"
                          placeholder='Enter Confirm Password'
                          className='form-control Color-box'
                          value={input.confirmPassword}
                          onChange={onInputChange}
                          onBlur={validateInput}
                        ></input>
                        {error.confirmPassword && <span className='err'>{error.confirmPassword}</span>}
                      </div>
                      <div className="text-center">
                        <ToastContainer />
                        {
                          isSpin ?
                            <button
                              type="button"
                              className="btn bg-white text-primary btn-block">
                              <CircularProgress
                                color='inherit' size={24}
                                sx={{
                                  color: 'green'
                                }} />
                            </button>
                            :
                            <input
                              type="submit"
                              value="SUBMIT"
                              className="btn btn-primary btn-block"
                              style={{ backgroundColor: '#00ADEE', border: 'none', boxShadow: 'none' }}
                            />
                        }
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgotPasswordConfirmation;